<template>
  <div class="login">
    <el-row :gutter="30">
      <el-col :span="2"><div style="color: transparent">占位符</div></el-col>
      <el-col :span="8" class="login-form">
        <!-- 右侧form -->
        <div class="form-box">
          <h2 title="巩留县智慧旅游平台">巩留县智慧旅游平台</h2>
          <p>Kazanqi integrated platform</p>
          <el-form ref="loginform" :model="form" :rules="rules">
            <el-form-item label="" prop="account">
              <el-input v-model="form.account" placeholder="请输入用户名">
                <icon-svg slot="prefix" class="iconsvg" icon-class="user" />
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input
                v-model="form.password"
                show-password
                placeholder="请输入密码"
              >
                <icon-svg slot="prefix" class="iconsvg" icon-class="pwd" />
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="code">
              <div class="flex_">
                <el-input v-model="form.code" placeholder="请输入验证码" />
                <div class="coderight" @click="refreshCode">
                  <SIdentify
                    :identifyCode="identifyCode"
                    @click="refreshCode"
                  ></SIdentify>
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="form.checked">记住密码</el-checkbox>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- </div> -->
      </el-col>
      <el-col :span="14">
        <div class="left-box">
          <login-back />
        </div>
      </el-col>
    </el-row>
    <div class="flower-box">
      <img
        class="flower flower1"
        src="../../assets/logo_images/flower1.png"
        alt=""
      />
      <img
        class="flower flower2"
        src="../../assets/logo_images/flower2.png"
        alt=""
      />
      <img
        class="flower flower3"
        src="../../assets/logo_images/flower3.png"
        alt=""
      />
      <img
        class="flower flower4"
        src="../../assets/logo_images/flower4.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
  import loginBack from './components/svgBg.vue'
  import SIdentify from './components/identify.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: { SIdentify, loginBack },
    data() {
      return {
        redirect: undefined,
        list: [],
        identifyCode: '',
        listSky: [2, 4, 1, 3, 5],
        form: {
          account: '',
          password: '',
          code: '',
          checked: false,
        },
        rules: {
          account: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
          code: [
            {
              required: true,
              validator: this.verification,
              trigger: 'blur',
            },
          ],
        },
      }
    },
    computed: {
      ...mapGetters({
        account: 'user/account',
      }),
    },
    created() {
      this.keyupEnter()
      // this.list = Array.from({ length: 30 }, (v, i) => i + 1)
    },
    mounted() {
      this.loginA()
      this.identifyCode = this.randomStr()
      // 账号密码赋值
      if (this.account && this.account.checked) {
        this.form = this.account
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          const query = route.query
          if (query) {
            this.redirect = query.redirect
            this.otherQuery = this.getOtherQuery(query)
          }
        },
        immediate: true,
      },
    },
    beforeDestroy() {
      this.$animejs.remove(['.ul-box li', '.login-form', '.card'])
    },
    methods: {
      keyupEnter() {
        document.onkeydown = (e) => {
          if (e.keyCode === 13) {
            this.onSubmit()
          }
        }
      },
      // 登录
      onSubmit() {
        console.log('1111!!')
        this.$refs.loginform.validate((valid) => {
          if (valid) {
            this.loading = true
            this.$store
              .dispatch('user/login', this.form)
              .then(() => {
                this.$router.push({
                  path: this.redirect || '/',
                  query: this.otherQuery,
                })
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      // 列表动效--暂时存放 没用
      listAnimate() {
        // 从左至右 渐入
        this.$animejs({
          targets: '.ul-box li',
          translateX: [-20, 0],
          opacity: [0, 1],
          easing: 'linear',
          duration: 300,
          delay: function (el, i) {
            return i * 100
          }, // 每个元素的延迟增加100毫秒。
        })
      },
      // form 动效
      loginA() {
        let anime = this.$animejs
        // form 动效card
        anime({
          targets: '.login-form',
          translateX: [-300, 0],
          easing: 'easeInOutSine',
        })
        // 卡片
        anime({
          targets: '.flower',
          translateY: [300, 0],
          points: '64 128 8.574 96 8.574 32 64 0 119.426 32 119.426 96',
          delay: anime.stagger(300),
          easing: 'easeInOutSine',
        })
      },
      getOtherQuery(query) {
        return Object.keys(query).reduce((acc, cur) => {
          if (cur !== 'redirect') {
            acc[cur] = query[cur]
          }
          return acc
        }, {})
      },
      // 验证输入的验证码是否正确
      verification(rule, value, callback) {
        let a = value.toUpperCase(),
          b = this.identifyCode.toUpperCase()
        if (value == null || String(value).trim() === '') {
          return callback(new Error('请输入验证码'))
        } else if (a != b) {
          return callback(new Error('验证码输入有误'))
        } else {
          return callback()
        }
      },
      // 重置验证码
      refreshCode() {
        this.form.code = ''
        this.identifyCode = this.randomStr()
      },
      random(max, min) {
        return Math.round(Math.random() * (max - min) + min)
      },
      randomStr() {
        //创建一个空字符，用于存放随机数/字母
        var strData = ''
        //生成随机字符库 (验证码四位，随机数三种，取公倍数12,所以循环4次。也可以是120次，1200次。)
        for (var i = 0; i < 4; i++) {
          var num = this.random(0, 9) //生成0-9的随机数
          var az = String.fromCharCode(this.random(97, 122)) //生成a-z
          var AZ = String.fromCharCode(this.random(65, 90)) //生成A-Z
          strData = strData + num + az + AZ //将生成的字符进行字符串拼接
        }
        var str = strData.slice(0, 4)
        // 随机取出 strData 中的四个数字，但是 不想在用一个循环  所以直接截取了strData 四个数字
        // for (var j = 0; j < 4; j++) {
        //   str += strData[this.random(0, strData.length - 1)]
        // }
        return str
      },
    },
  }
</script>
<style lang="scss" scoped>
  .flex_ {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-checkbox {
    float: left;
  }
  .login {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    color: #fff;
    font-size: 28px;
    position: relative;
    background: #bcf5f3;
    .login-form {
      padding-top: 18vh;
    }
    .form-box {
      position: relative;
      height: 67.812vh;
      background: #ffffff;
      box-shadow: 0px 0px 40px 0px rgba(22, 151, 146, 0.05);
      border-radius: 8px;
      padding: 4.6vh 30px;
      min-width: 420px;
      h2 {
        font-size: 32px;
        font-weight: 400;
        letter-spacing: 2px;
        min-width: 400px;
        text-align: left;
        color: #333;
        overflow: hidden; /*超出部分隐藏*/
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        white-space: nowrap;
        margin-bottom: 1vh;
      }
      p {
        font-size: 20px;
        color: #999;
        margin-bottom: 6vh;
        text-align: left;
      }
    }
    // 验证码
    .coderight {
      margin-left: 10px;
    }
    .left-box {
      position: relative;
      // height: 81vh;
    }

    // 花花
    .flower-box {
      position: absolute;
      bottom: -0.8%;
      left: 0;
      overflow: hidden;
      .flower2 {
        position: relative;
        left: -3%;
      }
      .flower3 {
        position: relative;
        left: -18%;
      }
      .flower4 {
        position: relative;
        left: -20%;
      }
    }
  }
  .el-button {
    width: 100%;
    height: 7vh;
    border: none;
    background: #21c777;
    font-size: 24px;
    border-radius: 0;
  }
  .iconsvg {
    margin: 2.5vh 0 0 8px;
  }
  ::v-deep {
    .el-form-item {
      margin-bottom: 3.7vh;
      font-size: 18px;
    }
    .el-input__inner {
      border-radius: 0;
      height: 7vh;
      line-height: 7vh;
      background: #f7f7f7;
      border: 1px solid #f7f7f7;
      color: #000;
      padding-left: 40px;
    }
    .el-form-item__content {
      line-height: 17px;
    }
  }
</style>
<style>
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 7vh #f7f7f7 inset; /*通过边框阴影遮挡住背景 */
    -webkit-text-fill-color: #b3b3b3; /*自动填充内容的文本颜色 */
  }
</style>
